<script setup>

import KdContainer from "./kdContainer.vue";
</script>

<template>
    <kd-container>
      <el-form label-width="30px">
        <!-- <div style="margin-top: 10px;"> -->
        <el-form-item style="margin-top: 15px;">
          <el-button class="lang-but" type="primary" @click="auditPassBtClick()">通过</el-button>
          <el-button class="lang-but" type="danger"  @click="auditRejectBtClick()">驳回</el-button>
        </el-form-item>

        <!-- </div> -->
      </el-form>

      <kd-audit-pass-dialog
        :visible.sync="auditPassDialogVisible"
        v-model="form.auditText"
        @confirm="onAuditPassConfirm"
      />

      <div>
        <el-dialog width="600px !important" title="审核驳回" :visible.sync="dialogVisible">
        <el-form :model="form" :rules="rules" ref="rejectFormRef" label-width="85px">
          <el-form-item label="驳回原因" prop="rejectReason">
            <el-input v-model="form.rejectReason" type="textarea" placeholder="请输入驳回原因" :autosize="{ minRows: 4, maxRows: 4 }" maxlength="500" show-word-limit></el-input>
          </el-form-item>
          <div class="submitArea">
            <el-button type="primary" @click="auditRejectSubmit()">提交</el-button>
            <el-button plain  @click="dialogVisible = false">取消</el-button>
          </div>
        </el-form>
      </el-dialog>
      </div>
    </kd-container>
</template>

<style scoped lang="scss">

</style>

<script>
import {requestSubmitAuditKD} from "@/api/feedbackKD";
import KdAuditPassDialog from "./kdAuditPassDialog.vue";

export default {
  name: "kdNormalAudit",
  inject: ['getValidateForm'],
  components: { KdAuditPassDialog },
  props: {
    taskId:String,
    questionId:String,
    taskDefKey:String
  },
  data() {
    return {
      dialogVisible:false,
      auditPassDialogVisible: false,
      form: {
        rejectReason: "",
        auditText: ""
      },
      rules: {
        rejectReason: [
          {
            required: true, message: "驳回原因不能为空", trigger: ["blur", "change"]
          }
        ]
      }
    }
  },
  methods: {
    async auditPassBtClick() {
      if (!await this.getValidateForm()) {
        return
      }
      this.auditPassDialogVisible = true;
    },
    onAuditPassConfirm(auditText) {
      let formData = {
        nowTaskId:this.taskId,
        questionId:this.questionId,
        taskDefKey:this.taskDefKey,
        auditText: auditText,
        variables:{
          approval: true
        },
      }
      requestSubmitAuditKD(formData).then(res => {
        if(res.status == "0"){
          this.$DonMessage.success('审批成功!');
          this.backRouterPath();
        }else {
          this.$DonMessage.error(res.message);
        }
      })
    },
    auditRejectBtClick() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.rejectFormRef?.resetFields();
      })
    },
    auditRejectSubmit(){
      this.$refs['rejectFormRef'].validate((valid, object) => {
        if (this.getRequiredValid(valid, object)){
          return
        }

        let formData = {
          nowTaskId: this.taskId,
          questionId: this.questionId,
          taskDefKey: this.taskDefKey,
          auditText: this.form.rejectReason,
          variables: {
            approval: false
          },
        }
        requestSubmitAuditKD(formData).then(res => {
          if (res.status == "0") {
            this.$DonMessage.success('驳回成功!');
            this.backRouterPath();
            this.dialogVisible = false;
          } else {
            this.$DonMessage.error(res.message);
          }
        })
      })
    }
  },
}
</script>
